module.exports = __webpack_public_path__ + "img/c-1.3f03d147.png";